module.exports = __webpack_public_path__ + "media/styles/images/svg/pencil-white-79af092ed0bb1c9a2df14aa354afd462.svg";